/**
 * ServersIcon/index.js
 * desc: servers icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ServersIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="servers icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.servers.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 16" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M0 0v4h20V0H0zm20 16H0v-4h20v4zM4 13H2v2h2v-2zM2 3h2V1H2v2zm-2 7h20V6H0v4zm4-3H2v2h2V7z" /></svg>
    </IconButton>
);


export default ServersIcon;
